import React from 'react';
import Layout from '../../Components/Layout/Layout';
import './Style.css';
import { useLocation } from 'react-router-dom';
import CalenderModals from '../../Components/Modals/Index';

const SearchInfo = ({ setLoading }) => {
    const location = useLocation();
    const { query, results } = location.state || {};
    const [selectedData, setSelectedData] = React.useState([]);
    const [showSelectedData, setShowSelectedData] = React.useState(false);

    const handleClose = () => {
        setShowSelectedData(false);
        setSelectedData();
    };

    const handelselectdata = (item) => {
        setSelectedData(item);
        setShowSelectedData(true);
    };

    const formatDate = (datetime) => {
        const date = new Date(datetime);
        const day = date.toLocaleString('en-US', { weekday: 'short' });
        const dayNumber = date.getDate();
        return { day, dayNumber };
    };

    const getMonthYear = (datetime) => {
        const date = new Date(datetime);
        const month = date.toLocaleString('en-US', { month: 'long' });
        const year = date.getFullYear();
        return { month, year, key: `${year}-${date.getMonth()}` };
    };

    const formatTime = (datetime) => {
        const date = new Date(datetime);
        return date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    };

    const groupedResults = results?.reduce((acc, item) => {
        const { month, year, key } = getMonthYear(item.start_datetime);
        if (!acc[key]) acc[key] = { month, year, events: [] };
        acc[key].events.push(item);
        return acc;
    }, {});

    const sortedGroups = Object.keys(groupedResults)
        .sort((a, b) => new Date(a) - new Date(b))
        .map((key) => groupedResults[key]);

    return (
        <>
            <Layout>
                <div className='year-date-heading-si'>
                    <div><h3>Search Results ({results?.length || 0})</h3></div>
                    {sortedGroups.length > 0 ? (
                        sortedGroups.map(({ month, year, events }, index) => {
                            const sortedEvents = events.sort((a, b) => {
                                const dayA = new Date(a.start_datetime).getDate();
                                const dayB = new Date(b.start_datetime).getDate();
                                return dayA - dayB;
                            });
                            return (
                                <div key={`${month}-${year}-${index}`}>
                                    <h4 className='month-year-heading'>{month} {year}</h4>
                                    {sortedEvents.map((item, idx) => {
                                        const { day, dayNumber } = formatDate(item.start_datetime);
                                        const startTime = formatTime(item.start_datetime);
                                        const endTime = formatTime(item.end_datetime);
                                        return (
                                            <div className='info-date-day-catname'>
                                                <div key={item.event_id} onClick={() => handelselectdata(item)} className='inner-info-date-day-catname'>
                                                    <div className='date-plus-day-si'>
                                                        <p className='day-in-si'>{day}</p>
                                                        <p className='num-in-si'>{dayNumber}</p>
                                                    </div>

                                                    <div
                                                        className={
                                                            item?.locations?.some(location => location.displayName?.startsWith('https'))
                                                                ? 'progressbar-lined'
                                                                : 'progressbar-plain'
                                                        }
                                                    ></div>
                                                    <div className='catname-sdate-edate'>
                                                        <p className='subject-cat-only'>
                                                            {item.subject.length > 35 ? item.subject.slice(0, 35) + '...' : item.subject}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className='inner-info-date-day-catname-two'>
                                                    <div className='date-loc-si'>
                                                        <p className='sdate-edate-si'> {startTime} - {endTime}</p>
                                                        {item?.locations?.map((location, index) => (
                                                            <p key={index} className='location-si'>
                                                                {location.displayName.length > 35
                                                                    ? location.displayName.slice(0, 35) + '...'
                                                                    : location.displayName}
                                                            </p>
                                                        ))}
                                                    </div>
                                                    <div className='org_cat-search'>
                                                        <p className='associate_color-search'>{item?.organizer_name}</p>

                                                        <p className='catname-cat-only'>
                                                            {item.categories.length ? item.categories : null}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })
                    ) : (
                        <p>No results found.</p>
                    )}
                </div>
                <CalenderModals open={showSelectedData} onClose={handleClose} event={selectedData} />
            </Layout>
        </>
    );
};
export default SearchInfo;